






















import {Component, Vue} from 'vue-property-decorator';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import api from '@/infrastructure/api/api';
import {APIバージョン情報型} from '@/type/version/version';
import version from '@/version';
import {progress} from '@/script/progress';

@Component({
  components: {
    NormalDialog,
  },
})
export default class VersionDialog extends Vue {
  private clientVersion: string = version;
  private apiVersion: APIバージョン情報型 = {
    spdVersion: 'Loading...',
    integrationVersion: 'Loading...',
  };

  private close() {
    this.$modal.hide('VersionDialog');
  }

  private async getApiVersion() {
    await progress(this.doGetRequest);
  }

  private async doGetRequest() {
    try {
      this.apiVersion = await api.getApiVersion();
    } catch (e) {
      this.close();
    }
  }
}
